export const Duration = [
  { id: 0, name: "Monthly" },
  { id: 1, name: "Half Monthly" },
  { id: 2, name: "Yearly" },
];
